import Avatar from 'emerald-ui/lib/Avatar';
import Nav from 'emerald-ui/lib/Nav';
import PageHeader from 'emerald-ui/lib/PageHeader';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: PageHeader, componentName: 'PageHeader' }], 'PageHeader'),
  description:
    'The PageHeader is the standard container that goes below the AppBar and hosts the page name, among other information. It can also contain the internal page navigation (tabs).',
  codeSamples: [
    {
      title: 'With Breadcrumbs',
      scope: { PageHeader },
      code: `<PageHeader>
  <ol className="breadcrumb">
    <li>
      <a href="#foo">
        <span className="chevron-back"></span>
        Back to John&rsquo;s profile
      </a>
    </li>
  </ol>
  <h1>Transcript</h1>
</PageHeader>`,
    },
    {
      title: 'With Navigation',
      scope: { Avatar, Nav, PageHeader },
      code: `<PageHeader>
  <h1 className="clearfix">
    <Avatar title="John Doe" size="md" className="pull-left" />
    <span className="h2">John Doe</span>
  </h1>
  <Nav>
    <a href="/apps/docs/static" className="active">MY PROFILE</a>
    <a href="/apps/docs/static">MY EMPLOYER</a>
    <a href="/apps/docs/static">BILLING</a>
    <a href="/apps/docs/static">NOTIFICATIONS</a>
    <a href="/apps/docs/static" disabled>
      DISABLED
    </a>
  </Nav>
</PageHeader>`,
    },
  ],
};
